<template>
  <editor-menu-bar :editor="editor">
    <div class="toolbar">
      <div v-for="(buttonGroup, i) in buttons" :key="i" class="toolbar-group">
        <toolbar-button v-for="button in buttonGroup" :key="button.text"
            :text="button.text" :icon="button.icon" :active="button.active"
            :enabled="button.enabled"
            :command="button.command" :commandArguments="button.commandArguments"/>
      </div>
    </div>
  </editor-menu-bar>
</template>

<script>
import { EditorMenuBar } from 'tiptap';

import ToolbarButton from './ToolbarButton.vue';

export default {
  name: 'TheToolbar',
  components: {
    EditorMenuBar,
    ToolbarButton,
  },
  props: [
    'editor',
    'buttons',
  ],
};
</script>

<style lang="scss" scoped>
.toolbar {
  &-group {
    display: inline-flex;
    padding: 0 0.5rem;

    :first-child {
      border-bottom-left-radius: 0.25rem;
      border-top-left-radius: 0.25rem;
    }

    :last-child {
      border-bottom-right-radius: 0.25rem;
      border-top-right-radius: 0.25rem;
    }
  }
}
</style>
